import { allTasksActionTypes } from './AllTasks.actionTypes';

const initialState = {
  allData: [],
  tempData: [],
  searchData: [],
  filterAssigneeData: [],
  filterStatusData: [],
  filterPriorityData: [],
};

const allTasksReducer = (state = initialState, action) => {
  switch (action.type) {
    case allTasksActionTypes.SET_ALL_DATA:
      return {
        ...state,
        allData: action.payload,
      };
    case allTasksActionTypes.SET_SEARCH_DATA:
      return {
        ...state,
        searchData: action.payload,
      };
    case allTasksActionTypes.SET_SEARCH_ASSIGNEE_DATA:
      return {
        ...state,
        filterAssigneeData: action.payload,
      };
    case allTasksActionTypes.SET_SEARCH_STATUS_DATA:
      return {
        ...state,
        filterStatusData: action.payload,
      };
    case allTasksActionTypes.SET_SEARCH_PRIORITY_DATA:
      return {
        ...state,
        filterPriorityData: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default allTasksReducer;
